const TYPE_RULES = [
  { type: 'sermon', pattern: /^(проповід|проповед)/i },
  { type: 'word',   pattern: /^вивчення\s+слова?/i },
  { type: 'choir',  pattern: /^(хор|хоровий)/i },
  { type: 'online', pattern: /(богослуж|вечеря|свято|пряма\s*трансляц|онлайн\s*трансляц)/i },
]

export function detectType(title) {
  if (!title) return 'sermon'
  for (var i = 0; i < TYPE_RULES.length; i++) {
    if (TYPE_RULES[i].pattern.test(title)) return TYPE_RULES[i].type
  }
  return 'sermon'
}

export function extractVideoId(link) {
  if (!link) return ''
  var m = link.match(/(?:v=|youtu\.be\/)([A-Za-z0-9_-]{11})/)
  return m ? m[1] : ''
}
